import styled from 'styled-components';
import { StockCardStyled } from '../StockCardStyled';
import { rem } from 'polished';

export const StockCardStyledDS = styled(StockCardStyled)`
    border: 1px solid ${({ theme }) => theme.colors.grey16};
    border-radius: ${rem(16)};
    padding-bottom: ${rem(16)};

    .delivery-date {
        span {
            font-size: ${({ theme }) => theme.fontSizes.h6};
            color: ${({ theme }) => theme.colors.black};
        }

        svg {
            width: ${rem(25)};
            height: ${rem(25)};
            position: relative;
            top: ${rem('1px')};
            left: ${rem('3px')};
        }
    }

    .catalogPrice {
        padding: 0;
 
        .catalogPriceLabel {
            font-size: ${rem('16px')};
            font-weight: normal;
        }
        .catalogPriceAmount {
            font-size: ${rem('16px')};
            font-weight: bold;
            .currencyLabel__suffix--OTR {
                font-size: ${rem('12px')};
            }
        }
    }
`;
